import { apiClient } from '@/services';

export const CarService = {
  getCarByCarTag({ carTag }) {
    return apiClient.get('/car-detail', {
      params: {
        carTag: carTag,
      },
    });
  },
  getCarInfo(carTag) {
    return apiClient.post('/car-data', null, {
      params: {
        carTag,
      },
    });
  },
  getConfiguratorManufacturers() {
    return apiClient.get('/car-manufacturer-overview');
  },
  getConfiguratorClasses(manufacturer) {
    return apiClient.get('/car-model-overview', {
      params: {
        brandName: manufacturer,
      },
    });
  },
  getConfiguratorTypes(payload) {
    return apiClient.get('/car-type-overview', {
      params: payload,
    });
  },
  getConfiguratorVersions(payload) {
    return apiClient.get('/car-engine-overview', {
      params: payload,
    });
  },
  getCarGroupByGermanCode(payload) {
    return apiClient.get('/cars/groups/german-code', {
      params: payload,
    });
  },
  getCarWheels(payload) {
    return apiClient.get('/configurator/car-wheels', {
      params: payload,
    });
  },
  getCarImage(payload) {
    return apiClient.get('/image', {
      params: payload,
    });
  },
  getCarWheelsConcatenated(payload) {
    return apiClient.get('/configurator/car-wheels-concatenated', {
      params: payload,
    });
  },
  getCertificateTexts(payload) {
    return apiClient.get('/configurator/certificate-texts', {
      params: payload,
    });
  },
  getCarHistory() {
    return apiClient.get('/cars/history');
  },
  setCarHistory(carTag) {
    return apiClient.post(`/cars/history/${carTag}`);
  },
  getCarCoc(carTags) {
    return apiClient.get('/cars/cocs', {
      params: {
        CarTags: carTags,
      },
    });
  },
};